import React from 'react'
import { Helmet } from 'react-helmet'
import { withSitecoreContext } from '@sitecore-jss/sitecore-jss-react'
import { withTranslation } from 'react-i18next'

interface Props {
  fields: {
    MobileWebAppCapable: string
    ThemeColor: string
    ApplicationName: string
    AppleMobileWebAppCapable: string
    AppleMobileWebAppStatusBarStyle: string
    AppleMobileWebAppTitle: string
    MsApplicationTileColor: string
    MsApplicationTileImage: string
    MsApplicationConfig: string
    YahooTableauWidget: string
    favicons: FaviconArray
  }
}

interface FaviconArray {
  Favicons: Favicon[]
}

interface Favicon {
  Rel: string
  Href: string
  Type: string
  Sizes: string
  Media: string
}

const Favicons: React.FC<Props> = (props) => {
  const { fields } = props

  return (
    <Helmet>
      <meta name="mobile-web-app-capable" content={fields.MobileWebAppCapable} />
      <meta name="theme-color" content={fields.ThemeColor} />
      <meta name="application-name" content={fields.ApplicationName} />
      <meta name="apple-mobile-web-app-capable" content={fields.AppleMobileWebAppCapable} />
      <meta name="apple-mobile-web-app-status-bar-style" content={fields.AppleMobileWebAppStatusBarStyle} />
      <meta name="apple-mobile-web-app-title" content={fields.AppleMobileWebAppTitle} />
      <meta name="msapplication-TileColor" content={fields.MsApplicationTileColor} />
      <meta name="msapplication-TileImage" content={fields.MsApplicationTileImage} />
      <meta name="msapplication-config" content={fields.MsApplicationConfig} />
      <meta name="yandex-tableau-widget" content={fields.YahooTableauWidget} />

      {(fields.favicons?.Favicons || []).map((favicon, index) => (
        <link
          key={index.toString()}
          href={favicon.Href}
          rel={favicon.Rel}
          media={favicon.Media}
          type={favicon.Type}
          sizes={favicon.Sizes}
        />
      ))}
    </Helmet>
  )
}

export default withSitecoreContext()(withTranslation()(Favicons as React.FC) as React.FC)
